import { render, staticRenderFns } from "./ride-rating-form.vue?vue&type=template&id=67d1cca8&scoped=true"
import script from "./ride-rating-form.vue?vue&type=script&lang=js"
export * from "./ride-rating-form.vue?vue&type=script&lang=js"
import style0 from "./ride-rating-form.vue?vue&type=style&index=0&id=67d1cca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1cca8",
  null
  
)

export default component.exports